import { buildAssetUrl } from './api';

export const normalizeProductCard = (product) => {
  const price = Number.parseFloat(product.starting_price ?? product.price ?? 0);
  const originalPrice = Number.parseFloat(product.original_price ?? product.originalPrice ?? price);
  const safePrice = Number.isFinite(price) ? price : 0;
  const safeOriginalPrice = Number.isFinite(originalPrice) ? originalPrice : safePrice;

  return {
    ...product,
    id: product.product_id ?? product.id,
    product_id: product.product_id ?? product.id,
    name: product.name ?? product.product_name ?? 'Product',
    image: buildAssetUrl(product.image ?? product.image1 ?? product.product_image ?? null),
    category: product.category_name ?? product.category ?? '',
    price: safePrice,
    originalPrice: safeOriginalPrice,
    gst: Number.parseFloat(product.gst ?? product.gst_percentage ?? 0) || 0,
    discount: safeOriginalPrice > safePrice
      ? Math.round(((safeOriginalPrice - safePrice) / safeOriginalPrice) * 100)
      : 0,
    unit: product.unit_name ?? product.unit ?? null,
    inStock: product.inStock ?? true,
  };
};
